import { Link } from "react-router-dom";
function NoMatch() {
  return (
    <div className="container mt-5 text-center">
      <h1 className="text-light">Error 404 – Page not found</h1>
      <Link className="btn btn-outline-light btn-lg ms-4" to="/">
        Go back to Home
      </Link>
    </div>
  );
}
export default NoMatch;
